module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), _c('page-title', {
    attrs: {
      "title": _vm.$t('dashboard.label')
    }
  }), _vm._v(" "), _c('panel', [_c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-3@md l-col-offset-9@md"
  }, [_c('el-date-picker', {
    staticClass: "u-floatRight",
    attrs: {
      "type": "daterange",
      "format": "dd/MM/yyyy",
      "start-placeholder": "Data Inicial",
      "end-placeholder": "Data Final"
    },
    on: {
      "change": _vm.onChange
    },
    model: {
      value: (_vm.options.date),
      callback: function($$v) {
        _vm.$set(_vm.options, "date", $$v)
      },
      expression: "options.date"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-3@md"
  }, [_c('box-info', {
    attrs: {
      "label": _vm.$t('orders.label'),
      "value": _vm.totalOrders,
      "fontSize": "30px",
      "loading": _vm.ordersByStatusReportLoading
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "l-col-3@md"
  }, [_c('box-info', {
    attrs: {
      "label": _vm.$t('pending.label'),
      "icon": "icon-clock",
      "value": _vm.totalOrdersPending,
      "fontSize": "30px",
      "color": "u-color-warning",
      "loading": _vm.ordersByStatusReportLoading
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "l-col-3@md"
  }, [_c('box-info', {
    attrs: {
      "label": _vm.$t('approved.label'),
      "icon": "icon-checkmark",
      "value": _vm.totalOrdersApproved,
      "fontSize": "30px",
      "color": "u-color-success",
      "loading": _vm.ordersByStatusReportLoading
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "l-col-3@md"
  }, [_c('box-info', {
    attrs: {
      "label": _vm.$t('canceled.label'),
      "icon": "icon-cross",
      "value": _vm.totalOrdersCanceled,
      "fontSize": "30px",
      "color": "u-color-danger",
      "loading": _vm.ordersByStatusReportLoading
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-12@md"
  }, [(_vm.ordersByMarketplaceAndDateChart) ? _c('line-chart', {
    attrs: {
      "identifier": "myChart",
      "data": _vm.ordersByMarketplaceAndDateChart,
      "loading": _vm.ordersByMarketplaceAndDateChartLoading
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-4@md"
  }, [_c('panel', {
    attrs: {
      "title": "Faturado"
    }
  }, [_c('loader', {
    attrs: {
      "loading": _vm.ordersExpeditionStepsReportLoading
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [(_vm.percentInvoice != 100) ? _c('button', {
    staticClass: "btn hint hint--left",
    attrs: {
      "data-label": "Verificar pendências"
    },
    on: {
      "click": _vm.redirectToOrderByInvoiceStatus
    }
  }, [_c('i', {
    staticClass: "icon-warning2"
  })]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "c-count__content count-info"
  }, [_vm._v("\n          " + _vm._s(_vm.currentInvoice) + "\n        ")]), _vm._v(" "), _c('progress', {
    staticClass: "progress progress--sm",
    attrs: {
      "max": "100"
    },
    domProps: {
      "value": _vm.percentInvoice
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "c-count__label count-label"
  }, [_vm._v(_vm._s(_vm.percentInvoice) + "% dos pedidos aprovados estão faturados")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "l-col-4@md"
  }, [_c('panel', {
    attrs: {
      "title": "Enviado"
    }
  }, [_c('loader', {
    attrs: {
      "loading": _vm.ordersExpeditionStepsReportLoading
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [(_vm.percentShipping != 100) ? _c('button', {
    staticClass: "btn hint hint--left",
    attrs: {
      "data-label": "Verificar pendências"
    },
    on: {
      "click": _vm.redirectToOrderByShippingStatus
    }
  }, [_c('i', {
    staticClass: "icon-warning2"
  })]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "c-count__content count-info"
  }, [_vm._v("\n          " + _vm._s(_vm.currentShipping) + "\n        ")]), _vm._v(" "), _c('progress', {
    staticClass: "progress progress--info progress--sm",
    attrs: {
      "max": "100"
    },
    domProps: {
      "value": _vm.percentShipping
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "c-count__label count-label"
  }, [_vm._v(_vm._s(_vm.percentShipping) + "% dos pedidos faturados estão enviados")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "l-col-4@md"
  }, [_c('panel', {
    attrs: {
      "title": "Entregue"
    }
  }, [_c('loader', {
    attrs: {
      "loading": _vm.ordersExpeditionStepsReportLoading
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [(_vm.percentDelivery != 100) ? _c('button', {
    staticClass: "btn hint hint--left",
    attrs: {
      "data-label": "Verificar pendências"
    },
    on: {
      "click": _vm.redirectToOrderByDeliveryStatus
    }
  }, [_c('i', {
    staticClass: "icon-warning2"
  })]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "c-count__content count-info"
  }, [_vm._v("\n          " + _vm._s(_vm.currentDelivery) + "\n        ")]), _vm._v(" "), _c('progress', {
    staticClass: "progress progress--warning progress--sm",
    attrs: {
      "max": "100"
    },
    domProps: {
      "value": _vm.percentDelivery
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "c-count__label count-label"
  }, [_vm._v(_vm._s(_vm.percentDelivery) + "% dos pedidos enviados estão entregues")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "l-row vertical-flex"
  }, [_c('div', {
    staticClass: "l-col-8@md"
  }, [_c('panel', {
    attrs: {
      "title": "Últimos pedidos"
    }
  }, [_c('loader', {
    attrs: {
      "loading": _vm.lastOrdersLoading
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [_c('router-link', {
    staticClass: "c-menu__link",
    attrs: {
      "to": "orders"
    }
  }, [_vm._v("Ver todos")])], 1), _vm._v(" "), (_vm.lastOrders.length) ? _c('table', {
    staticClass: "table table--responsive"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('id.label')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('total.label')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('status.label')))]), _vm._v(" "), _c('th', {
    staticClass: "u-textRight"
  }, [_vm._v(_vm._s(_vm.$t('date.label')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.lastOrders), function(lastOrder) {
    return _c('tr', [_c('td', {
      attrs: {
        "data-label": _vm.$t('id.label')
      }
    }, [_c('router-link', {
      staticClass: "hint hint--right",
      attrs: {
        "to": {
          name: 'order',
          params: {
            identifier: lastOrder.marketplace.identifier,
            code: lastOrder.marketplace.code
          }
        },
        "data-label": "Clique aqui para acessar"
      }
    }, [_vm._v("\n                  #" + _vm._s(lastOrder.marketplace.code) + "\n                ")])], 1), _vm._v(" "), _c('td', {
      attrs: {
        "data-label": _vm.$t('total.label')
      }
    }, [_vm._v(_vm._s(_vm._f("currency")(lastOrder.payment.total)))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-label": _vm.$t('status.label')
      }
    }, [_c('span', {
      staticClass: "badge",
      class: lastOrder.status,
      attrs: {
        "slot": "header-right"
      },
      slot: "header-right"
    }, [_vm._v(_vm._s(_vm.$t(lastOrder.status).label))])]), _vm._v(" "), _c('td', {
      staticClass: "u-textRight",
      attrs: {
        "data-label": _vm.$t('date.label')
      }
    }, [_vm._v("\n                " + _vm._s(_vm._f("moment")(lastOrder.created, 'DD/MM/YYYY HH:mm')) + "\n              ")])])
  }), 0)]) : _vm._e(), _vm._v(" "), (!_vm.lastOrders.length) ? _c('div', {
    staticClass: "u-textCenter teste"
  }, [_vm._v("\n          Nenhum pedido encontrado.\n        ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "l-col-4@md"
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-12@md"
  }, [_c('panel', {
    attrs: {
      "title": "Faturamento"
    }
  }, [_c('loader', {
    attrs: {
      "loading": _vm.ordersIncomingReportLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "l-level"
  }, [_c('div', {
    staticClass: "l-level__item c-count"
  }, [_c('div', {
    staticClass: "c-count__content"
  }, [_vm._v("\n                  " + _vm._s(_vm._f("currency")(_vm.ordersIncoming.current.total)) + "\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "percent-incoming"
  }, [_c('i', {
    staticClass: "icon percent-icon",
    class: _vm.arrowIncomingTotal
  }), _vm._v("\n                  " + _vm._s(_vm.ordersIncoming.current.percentTotal) + "%\n                ")])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "l-col-12@md"
  }, [_c('panel', {
    attrs: {
      "title": "Custo de transporte"
    }
  }, [_c('loader', {
    attrs: {
      "loading": _vm.ordersIncomingReportLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "l-level"
  }, [_c('div', {
    staticClass: "l-level__item c-count"
  }, [_c('div', {
    staticClass: "c-count__content"
  }, [_vm._v("\n                  " + _vm._s(_vm._f("currency")(_vm.ordersIncoming.current.shipping)) + "\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "percent-incoming"
  }, [_c('i', {
    staticClass: "icon percent-icon",
    class: _vm.arrowIncomingShipping
  }), _vm._v("\n                  " + _vm._s(_vm.ordersIncoming.current.percentShipping) + "%\n                ")])])])], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "l-row vertical-flex"
  }, [_c('div', {
    staticClass: "l-col-4@md"
  }, [_c('panel', {
    attrs: {
      "title": "Produtos"
    }
  }, [(_vm.quantityProductsByStatus && _vm.quantityProductsByStatus.labels.length) ? _c('pie-chart', {
    attrs: {
      "identifier": "productsByStatuses",
      "data": _vm.quantityProductsByStatus,
      "loading": _vm.quantityProductsByStatusLoading
    }
  }) : _c('div', {
    staticClass: "u-textCenter teste"
  }, [_vm._v("\n          Nenhuma informação de produto foi atualizada no filtro de data utilizado.\n        ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "l-col-4@md"
  }, [_c('panel', {
    attrs: {
      "title": "Preços"
    }
  }, [(_vm.quantityPricesByStatus && _vm.quantityPricesByStatus.labels.length) ? _c('pie-chart', {
    attrs: {
      "identifier": "pricesByStatuses",
      "data": _vm.quantityPricesByStatus,
      "loading": _vm.quantityPricesByStatusLoading
    }
  }) : _c('div', {
    staticClass: "u-textCenter teste"
  }, [_vm._v("\n          Nenhum preço foi atualizado no filtro de data utilizado.\n        ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "l-col-4@md"
  }, [_c('panel', {
    attrs: {
      "title": "Estoques"
    }
  }, [(_vm.quantityStocksByStatus && _vm.quantityStocksByStatus.labels.length) ? _c('pie-chart', {
    attrs: {
      "identifier": "stocksByStatuses",
      "data": _vm.quantityStocksByStatus,
      "loading": _vm.quantityStocksByStatusLoading
    }
  }) : _c('div', {
    staticClass: "u-textCenter teste"
  }, [_vm._v("\n          Nenhum estoque foi atualizado no filtro de data utilizado.\n        ")])], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5342f674","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Dashboard/Base.vue
// module id = 3170
// module chunks = 0